import { ChevronRight, X as CloseIcon } from 'lucide-react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import type { RootState } from '~/redux/store';
import UserProfile from './UserProfile';
import { navItems } from '~/layout/config';

interface SideNavProps {
  onNavigate?: () => void;
}

export default function SideNav({ onNavigate }: SideNavProps) {
  const user = useSelector((state: RootState) => state.auth.user);
  const role = user?.role;
  const roleBasedNavItems = navItems.filter((item) =>
    item.requiredRoles.includes(role?.toLowerCase() || '')
  );

  return (
    <aside className="w-full h-full  bg-white flex flex-col justify-between relative border-r border-neut-bg">
      <div className="flex flex-col items-start justify-between px-6">
        <h1 className="text-2xl leading-[36px] font-semibold tracking-tight text-neut-prim">
          TIMBERBASE
        </h1>
        <p className="text-sm text-neut-sec capitalize font-normal leading-[20px]">
          {role} Portal
        </p>

        <CloseIcon
          onClick={onNavigate}
          color="var(--color-neut-600)"
          className="lg:hidden cursor-pointer absolute top-1 right-6"
        />
      </div>

      <nav className="py-6 px-3  flex w-full">
        <ul className="w-full flex flex-col gap-1">
          {roleBasedNavItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                <NavLink
                  to={item.to}
                  onClick={onNavigate}
                  className={({ isActive }) => `
                    w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
                    transition-colors
                    ${
                      isActive
                        ? 'bg-prim text-neut-0'
                        : 'text-neut-prim hover:bg-neut-bg'
                    }
                  `}
                >
                  {({ isActive }) => (
                    <>
                      <Icon size={18} />
                      <span className="flex-1 text-left">{item.label}</span>
                      {isActive && (
                        <ChevronRight size={16} className={'text-neut-0'} />
                      )}
                    </>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      <UserProfile />
    </aside>
  );
}
